/* form-embed D3: Telify's page for a form on the studio's website (mockup 1.1), framed as the form request page frames its form. */
@layer telify {
  .page {
    width: min(680px, calc(100% - 80px));
    margin: 0 auto;
    padding: 34px 0 72px;
  }

  .head {
    display: grid;
    gap: 14px;
    margin-bottom: 30px;
  }

  .name {
    margin: 10px 0 0;
    font-family: var(--font-display);
    font-weight: 500;
    font-size: 52px;
    line-height: 1.08;
    letter-spacing: -0.015em;
    color: var(--text-primary);
  }

  .desc {
    margin: 0;
    max-width: 60ch;
    font-size: 16px;
    line-height: 1.6;
    color: var(--text-secondary);
  }

  @media (max-width: 1023px) {
    .page {
      width: calc(100% - 32px);
    }

    .name {
      font-size: 40px;
    }
  }
}
